export default "__VITE_ASSET__BhcQpREh__"